export const LobbyFirmRegistrations = (
    <div className="flex flex-col gap-2">
        <div>
            This exhibit lists registrations started within the last 12 months, or communicated
            upon in the last 12 months, regardless of when they were originally
            started.
        </div>
    </div>
);
